var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20028,
    height: 32769,
    viewBox: "0 0 20028 32769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_25923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6632.96 21445.3L8672.85 20808.8L8201.65 19185.5L9911.15 17097.3L11325.8 18255.3L12787.1 16470.2L11675.8 14941.6L7856.92 14178L6186.69 18211.1L6632.96 21445.3Z",
    fill: "#0041ED"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8254.35 16004.8L8276.75 16009.7",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8294.48 16077.1L8325.25 16083.8",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8241.13 16065.5L8256.52 16068.8",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8315.69 16017.5L8328.91 15956.8",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8383.52 15842.3L8404.15 15747.7L8377.69 15741.9",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8510.05 15627.5L8478.6 15620.6",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8355.98 15737.2L8270.91 15718.6",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8410.13 15593.1L8407.5 15605.1L8478.59 15620.6",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8415.98 15663.6L8420.84 15671.2L8410.08 15720.5",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8293.35 15615.6L8400.13 15638.9L8402.91 15643.2L8406.62 15649",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8392.83 15799.6L8259.59 15770.6",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8309.87 16080.5L8323.09 16019.8",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8367.58 16028.8L8371.21 16012.1",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8377.03 15985.4L8380.65 15968.8",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8344.89 16088.1L8375.66 16094.8L8388.88 16034.1L8292.72 16013.2",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8267.57 15944.2L8390.48 15970.9L8412.17 15871.4L8289.27 15844.6L8226.9 16130.8L8205.85 16144.3L8200.53 16168.7L8214.04 16189.7L8238.48 16195.1L8259.52 16181.6L8335.71 16198.2L8355.96 16185.2L8369.28 16124.1",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8331.88 15786.3L8338.38 15756.5",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8514.76 15695.5L8465.05 15684.7L8454.97 15730.9",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8397.54 16146.5L8365.88 16139.6L8367.32 16133.1",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8482.87 15841.8L8433.17 15830.9L8443.25 15784.7",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8414.13 15574.7L8430.2 15501",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8621.49 16084.8L8599.09 16079.9",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8554.91 16133.9L8524.14 16127.2",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8608.26 16145.5L8592.88 16142.1",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8560.44 16070.8L8573.66 16010.2",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8571.66 15883.3L8592.29 15788.7L8618.75 15794.4",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8546.01 15635.3L8577.46 15642.2",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8640.46 15799.2L8725.53 15817.7",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8577.46 15642.2L8648.56 15657.7L8651.19 15645.6",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8616.52 15707.3L8608.95 15712.2L8598.18 15761.6",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8747.98 15714.7L8641.2 15691.5L8636.88 15694.2L8631.1 15697.9",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8580.96 15840.6L8714.21 15869.7",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8539.52 16130.5L8552.75 16069.8",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8508.55 16059.5L8512.18 16042.9",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8518 16016.2L8521.63 15999.5",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8504.51 16122.9L8473.74 16116.2L8486.96 16055.5L8583.11 16076.5",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8634.7 16024.2L8511.8 15997.4L8533.5 15897.8L8656.4 15924.6L8594.03 16210.8L8607.55 16231.8L8602.22 16256.3L8581.18 16269.8L8556.74 16264.4L8543.22 16243.4L8467.03 16226.8L8454.03 16206.6L8467.35 16145.5",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8641.91 15853.9L8648.41 15824.1",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8513.43 15695.2L8563.13 15706L8553.05 15752.3",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8432.31 16154.1L8463.96 16161L8465.39 16154.4",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8481.54 15841.5L8531.25 15852.3L8541.33 15806.1",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8655.18 15627.3L8671.26 15553.5",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8533.5 15897.8L8701.16 15934.4L8769.96 15618.7L8791 15605.2L8796.33 15580.8L8782.82 15559.8L8758.38 15554.4L8737.33 15567.9L8616.78 15541.7L8596.54 15554.7L8577.46 15642.2",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8412.18 15871.4L8244.52 15834.9L8313.32 15519.2L8299.8 15498.2L8305.13 15473.7L8326.17 15460.2L8350.61 15465.5L8364.13 15486.6L8484.68 15512.9L8497.67 15533.1L8478.6 15620.6",
    stroke: "white",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8538.19 15604.3C8546.58 15604.3 8553.38 15597.5 8553.38 15589.1C8553.38 15580.8 8546.58 15573.9 8538.19 15573.9C8529.8 15573.9 8522.99 15580.8 8522.99 15589.1C8522.99 15597.5 8529.8 15604.3 8538.19 15604.3Z",
    fill: "#FF600F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8543.82 15597.9L8532.55 15580.4",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8529.41 15594.8L8546.96 15583.5",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8406.26 16206.6C8414.65 16206.6 8421.45 16199.8 8421.45 16191.4C8421.45 16183.1 8414.65 16176.2 8406.26 16176.2C8397.86 16176.2 8391.06 16183.1 8391.06 16191.4C8391.06 16199.8 8397.86 16206.6 8406.26 16206.6Z",
    fill: "#FF600F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8411.89 16200.2L8400.62 16182.7",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8397.48 16197.1L8415.03 16185.8",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeLinejoin: "bevel"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8454.36 15579.1C8462.75 15579.1 8469.55 15572.3 8469.55 15563.9C8469.55 15555.5 8462.75 15548.7 8454.36 15548.7C8445.96 15548.7 8439.16 15555.5 8439.16 15563.9C8439.16 15572.3 8445.96 15579.1 8454.36 15579.1Z",
    fill: "#0FA478"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8446.94 15563.5L8450.68 15569.3L8461.83 15558.7",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8363.8 15575.1C8372.2 15575.1 8379 15568.3 8379 15560C8379 15551.6 8372.2 15544.8 8363.8 15544.8C8355.41 15544.8 8348.61 15551.6 8348.61 15560C8348.61 15568.3 8355.41 15575.1 8363.8 15575.1Z",
    fill: "#0FA478"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8356.39 15559.5L8360.13 15565.3L8371.28 15554.8",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8346.2 15699.8C8354.6 15699.8 8361.4 15693 8361.4 15684.6C8361.4 15676.3 8354.6 15669.4 8346.2 15669.4C8337.81 15669.4 8331.01 15676.3 8331.01 15684.6C8331.01 15693 8337.81 15699.8 8346.2 15699.8Z",
    fill: "#0FA478"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8338.79 15684.2L8342.54 15690L8353.68 15679.5",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8498.92 15785.1C8507.31 15785.1 8514.11 15778.3 8514.11 15769.9C8514.11 15761.5 8507.31 15754.7 8498.92 15754.7C8490.53 15754.7 8483.72 15761.5 8483.72 15769.9C8483.72 15778.3 8490.53 15785.1 8498.92 15785.1Z",
    fill: "#0FA478"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8491.5 15769.5L8495.25 15775.3L8506.39 15764.7",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8678.01 15769.9C8686.4 15769.9 8693.21 15763.1 8693.21 15754.7C8693.21 15746.3 8686.4 15739.5 8678.01 15739.5C8669.62 15739.5 8662.81 15746.3 8662.81 15754.7C8662.81 15763.1 8669.62 15769.9 8678.01 15769.9Z",
    fill: "#0FA478"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8670.6 15754.3L8674.34 15760.1L8685.49 15749.5",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8626.16 15614.1C8634.55 15614.1 8641.35 15607.3 8641.35 15598.9C8641.35 15590.5 8634.55 15583.7 8626.16 15583.7C8617.76 15583.7 8610.96 15590.5 8610.96 15598.9C8610.96 15607.3 8617.76 15614.1 8626.16 15614.1Z",
    fill: "#0FA478"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8618.74 15598.4L8622.48 15604.3L8633.63 15593.7",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8712.01 15645.2C8720.41 15645.2 8727.21 15638.4 8727.21 15630C8727.21 15621.6 8720.41 15614.8 8712.01 15614.8C8703.62 15614.8 8696.82 15621.6 8696.82 15630C8696.82 15638.4 8703.62 15645.2 8712.01 15645.2Z",
    fill: "#0FA478"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8704.6 15629.5L8708.34 15635.3L8719.49 15624.8",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8340.82 15925.5C8349.21 15925.5 8356.02 15918.7 8356.02 15910.3C8356.02 15901.9 8349.21 15895.1 8340.82 15895.1C8332.43 15895.1 8325.62 15901.9 8325.62 15910.3C8325.62 15918.7 8332.43 15925.5 8340.82 15925.5Z",
    fill: "#0FA478"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8333.41 15909.9L8337.15 15915.7L8348.29 15905.1",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8291.75 16156.7C8300.14 16156.7 8306.94 16149.9 8306.94 16141.5C8306.94 16133.1 8300.14 16126.3 8291.75 16126.3C8283.35 16126.3 8276.55 16133.1 8276.55 16141.5C8276.55 16149.9 8283.35 16156.7 8291.75 16156.7Z",
    fill: "#0FA478"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M8284.33 16141L8288.07 16146.9L8299.22 16136.3",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8583.48 15980.3C8591.87 15980.3 8598.67 15973.5 8598.67 15965.1C8598.67 15956.7 8591.87 15949.9 8583.48 15949.9C8575.08 15949.9 8568.28 15956.7 8568.28 15965.1C8568.28 15973.5 8575.08 15980.3 8583.48 15980.3Z",
    fill: "#0FA478"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8576.06 15964.7L8579.8 15970.5L8590.95 15959.9",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M8532.91 16197.5C8541.3 16197.5 8548.1 16190.7 8548.1 16182.3C8548.1 16173.9 8541.3 16167.1 8532.91 16167.1C8524.51 16167.1 8517.71 16173.9 8517.71 16182.3C8517.71 16190.7 8524.51 16197.5 8532.91 16197.5Z",
    fill: "#0FA478"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M8525.49 16181.8L8529.23 16187.6L8540.38 16177.1",
    stroke: "#0041ED",
    strokeWidth: 1.61491,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_25923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10573.8,
    height: 11642.1,
    fill: "white",
    transform: "translate(6186.69 14178) scale(0.624225)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.09d7633cc1e2cdf1804c1105568b8863.svg";
export { ForwardRef as ReactComponent };